"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var html_entities_1 = require("html-entities");
var Subtitles = (function (_super) {
    __extends(Subtitles, _super);
    function Subtitles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityDecoder = new html_entities_1.XmlEntities();
        _this.defaultStyles = {
            position: 'absolute',
            left: '0px',
            right: '0px',
            bottom: '15%',
            color: '#f2f2f2',
            font: "3vmax 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 'bolder',
            textAlign: 'center',
            textShadow: '#000 0px 0px 7px',
        };
        return _this;
    }
    Subtitles.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.props.className, style: this.props.className ? undefined : this.defaultStyles }, this.props.textItems &&
            this.props.textItems.map(function (_a, key) {
                var text = _a.text;
                return (React.createElement("span", { key: key },
                    _this.entityDecoder.decode(text),
                    React.createElement("br", null)));
            })));
    };
    Subtitles.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.textItems !== nextProps.textItems || this.props.className !== nextProps.className;
    };
    return Subtitles;
}(React.Component));
exports.Subtitles = Subtitles;
